// React-imports
import { ReactElement, useEffect, useState } from "react";

// Style Imports
import "./verification-password.scss";

const VerificationPassword: React.FC = (): ReactElement => {
  const [device, setDevice] = useState<string>("");

  useEffect(() => {
    if (navigator.userAgent.toLowerCase().includes("android")) {
      setDevice("android");
    } else if (/(iPad|iPhone|iPod)/.test(navigator.userAgent)) {
      setDevice("ios");
    } else {
      setDevice("pc");
    }
  }, []);

  return (
    <div className="flex flex-col verification-password items-center min-h-screen">
      <div className="background"></div>
      <img src="./images/kamco-logo.png" alt="kamco invest" />
      <div className="white-container">
        <table>
          <tr>
            <td>
              <img
                src="./images/verified.svg"
                alt="kamco registeration-image"
              />
            </td>
          </tr>
          <tr>
            <td>
              <span>Verification completed</span>
            </td>
          </tr>
        </table>
        <span className="border"></span>
        <p className="first-p">
          <b>Congratulations!</b>, Your phone has been successfully verified.
          Thank you for confirming your phone with us. You are now all
          set to enjoy the full benefits of our services.
        </p>
        <p>
          If you have any questions or need further assistance, feel free to
          reach out to our support team.
        </p>
        <p>
          You can now go back to Kamco app to continue the registration process.
        </p>
        {/* {device !== "pc" && (
          <a
            href={
              device === "android"
                ? "intent://scan/#Intent;scheme=zxing;package=com.kamco.stage.android;end"
                : "kamcoInvest://"
            }
            className="button text-sm md:text-base w-full"
          >
            Back to mobile application
          </a>
        )} */}
        <p className="mt-7 text-lg text-blue-500">
          <b>Welcome aboard!</b>
        </p>
      </div>
      <footer className=" flex flex-col mt-auto">
        <ul>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.linkedin.com/company/kamco-invest/"
            >
              <img src="./images/linkedin.svg" alt="kamco invest linkedin" />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.facebook.com/kamcoinvest"
            >
              <img src="./images/facebook.svg" alt="kamco invest facebook" />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://twitter.com/KamcoInvest"
            >
              <img src="./images/twitter.svg" alt="kamco twitter x" />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/kamco_invest/?hl=en"
            >
              <img src="./images/instagram.svg" alt="kamco instagram" />
            </a>
          </li>
        </ul>
        <p className="text-sm md:text-base">
          Copyright © 2024 Kamco Invest. All Rights Reserved
        </p>
      </footer>
    </div>
  );
};

export default VerificationPassword;
